import React, { Component } from 'react';

import './Footer.scss';

class Footer extends Component {
  constructor (props) {
    super(props);

    this.onFooterMenuChange = this.onFooterMenuChange.bind(this);
  }

  onFooterMenuChange (event) {
    console.log(event.target.value);
    return this.props.navigate(event.target.value)(event);
  }

  render () {
    return (
      <div>
        <div className='footer'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-md-6'>
                <div className='contact-info--traditional'>
                  <h5>Contact Us</h5>
                  <p>info@paragonone.com</p>
                  <p>1-800-527-6888</p>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='contact-info--social'>
                  <img src='/images/universal/wechat.png' alt='Paragon One WeChat' className='social-image--wechat' />
                  <img src='/images/universal/qr-code.png' alt='Paragon One QR code' className='social-image--qr' />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='mobile-footer-pusher' />
        <div className='mobile-footer'>
          <div className='container-fluid'>
            <div className='col'>
              <label htmlFor='mobile-nav'>Jump to: </label>
              <span>&nbsp;</span>
              <select name='mobile-nav' className='custom-select' onChange={this.onFooterMenuChange}>
                <option value='header'>Top of the page</option>
                <option value='how-you-scored'>How You Scored</option>
                <option value='your-learning-roadmap'>Your Learning Roadmap</option>
                <option value='lets-get-started'>Let's Get Started</option>
                <option value='contact-us'>Contact Us</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/routes/student-report/routes/StudentReport/components/StudentReport/components/Footer/index.js